/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ListAgentDeptResponse as AgentApiContractAgentDeptListAgentDeptResponse } from '../models/AgentApi/Contract/AgentDept/list-agent-dept-response';
import { apiAgentAddAgentDeptPost } from '../fn/agent-sites/api-agent-add-agent-dept-post';
import { ApiAgentAddAgentDeptPost$Params } from '../fn/agent-sites/api-agent-add-agent-dept-post';
import { apiAgentListAgentDeptGet } from '../fn/agent-sites/api-agent-list-agent-dept-get';
import { ApiAgentListAgentDeptGet$Params } from '../fn/agent-sites/api-agent-list-agent-dept-get';
import { apiAgentListAgentDeptGet$Plain } from '../fn/agent-sites/api-agent-list-agent-dept-get-plain';
import { ApiAgentListAgentDeptGet$Plain$Params } from '../fn/agent-sites/api-agent-list-agent-dept-get-plain';
import { apiAgentRemoveAgentDeptDelete } from '../fn/agent-sites/api-agent-remove-agent-dept-delete';
import { ApiAgentRemoveAgentDeptDelete$Params } from '../fn/agent-sites/api-agent-remove-agent-dept-delete';
import { apiAgentSetAgentDeptPost } from '../fn/agent-sites/api-agent-set-agent-dept-post';
import { ApiAgentSetAgentDeptPost$Params } from '../fn/agent-sites/api-agent-set-agent-dept-post';

@Injectable({ providedIn: 'root' })
export class AgentSitesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgentListAgentDeptGet()` */
  static readonly ApiAgentListAgentDeptGetPath = '/api/Agent/ListAgentDept';

  /**
   * Getting a list of Agent sites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentDeptGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentDeptGet$Plain$Response(params?: ApiAgentListAgentDeptGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>> {
    return apiAgentListAgentDeptGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of Agent sites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentDeptGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentDeptGet$Plain(params?: ApiAgentListAgentDeptGet$Plain$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentDeptListAgentDeptResponse>> {
    return this.apiAgentListAgentDeptGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>): Array<AgentApiContractAgentDeptListAgentDeptResponse> => r.body)
    );
  }

  /**
   * Getting a list of Agent sites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentListAgentDeptGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentDeptGet$Response(params?: ApiAgentListAgentDeptGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>> {
    return apiAgentListAgentDeptGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of Agent sites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentListAgentDeptGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentListAgentDeptGet(params?: ApiAgentListAgentDeptGet$Params, context?: HttpContext): Observable<Array<AgentApiContractAgentDeptListAgentDeptResponse>> {
    return this.apiAgentListAgentDeptGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentApiContractAgentDeptListAgentDeptResponse>>): Array<AgentApiContractAgentDeptListAgentDeptResponse> => r.body)
    );
  }

  /** Path part for operation `apiAgentAddAgentDeptPost()` */
  static readonly ApiAgentAddAgentDeptPostPath = '/api/Agent/AddAgentDept';

  /**
   * Adding an Agent site.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentAddAgentDeptPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentDeptPost$Response(params?: ApiAgentAddAgentDeptPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentAddAgentDeptPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Adding an Agent site.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentAddAgentDeptPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentAddAgentDeptPost(params?: ApiAgentAddAgentDeptPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentAddAgentDeptPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentSetAgentDeptPost()` */
  static readonly ApiAgentSetAgentDeptPostPath = '/api/Agent/SetAgentDept';

  /**
   * Editing the data of the Agent's site.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentSetAgentDeptPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentDeptPost$Response(params?: ApiAgentSetAgentDeptPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentSetAgentDeptPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Editing the data of the Agent's site.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentSetAgentDeptPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentSetAgentDeptPost(params?: ApiAgentSetAgentDeptPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentSetAgentDeptPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentRemoveAgentDeptDelete()` */
  static readonly ApiAgentRemoveAgentDeptDeletePath = '/api/Agent/RemoveAgentDept';

  /**
   * Deleting an Agent site.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentRemoveAgentDeptDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentRemoveAgentDeptDelete$Response(params?: ApiAgentRemoveAgentDeptDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgentRemoveAgentDeptDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deleting an Agent site.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentRemoveAgentDeptDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentRemoveAgentDeptDelete(params?: ApiAgentRemoveAgentDeptDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiAgentRemoveAgentDeptDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
